var $bff6557112f09a21$exports = {};
$bff6557112f09a21$exports = {
    "Empty": `Vazio`
};


export {$bff6557112f09a21$exports as default};
//# sourceMappingURL=pt-BR.mjs.map
